var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_new message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.75 7.5V11.625C15.75 12.0228 15.592 12.4044 15.3107 12.6857C15.0294 12.967 14.6478 13.125 14.25 13.125H8.1113C7.24622 13.125 6.42324 13.4984 5.85357 14.1495L4.125 16.125V13.7669C4.125 13.3909 3.86612 13.0643 3.5 12.9786V12.9786C2.76776 12.807 2.25 12.1539 2.25 11.4018V4.125C2.25 3.72718 2.40804 3.34564 2.68934 3.06434C2.97064 2.78304 3.35218 2.625 3.75 2.625H7.875",
    stroke: "#B0BEC5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M12.75 1.5V7.5",
    stroke: "#B0BEC5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M9.75 4.5L15.75 4.5",
    stroke: "#B0BEC5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewMessage);
export default __webpack_public_path__ + "static/media/icon_new_message.f986ad6d62f7bcba5bf645e430ca98c9.svg";
export { ForwardRef as ReactComponent };